export const api = {
    getBooksCatalogueByNavStrId : "/app/getBooksCatalogue/",
    getArticleInfo : "/app/article/view/",
    getBooksList : "/app/getBooksList",
    search : "/app/search",
    getHomeRowData : "/app/home/getRowData",
}
